import React, { useRef } from 'react'
import './contact.css'
import { AiOutlineMail, } from 'react-icons/ai'
import 'react-toastify/dist/ReactToastify.css';
import emailjs from '@emailjs/browser';
import { toast } from 'react-hot-toast';



export const Contact = () => {
    const form = useRef()
    const sentEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATE_ID, form.current, process.env.REACT_APP_PUBLICKEY)
            .then((response) => {
                console.log('SUCCESS!', response.status, response.text);
                toast.success('Message Send SuccessFull ✅')
            }, (err) => {
                toast.error(err.text)

            })
        e.target.reset()

    }
    return (
        <div id='contact' className='contact mt-5'>
            <h1 className='text-center'>Contact Me</h1>
            <div className='container contact__container'>
                <div className='row'>
                    <div className='col-lg-4'>
                        <div className='contact__options'>
                            <a href='mailto:mnvasanthcode@gmail.com' className='contact__detail' >
                                <article className='contact__option'>

                                    <AiOutlineMail className='contact_icon' />
                                    <h4>Email</h4>
                                    <h5 style={{ fontSize: 15 }}>mnvasanthcode@gmail.com</h5>

                                </article>
                            </a>

                        </div>
                    </div>

                    <div className='col-lg-8'>

                        <form action='' ref={form} onSubmit={sentEmail}>

                            <input type="text"
                                placeholder='Your Name'
                                name='name'
                            />
                            <input type="text"
                                name='email'
                                placeholder='Your Email'
                                required />
                            <textarea type="text"
                                name='message'
                                placeholder='message'
                                required />
                            <button

                                // onClick={sentEmail}
                                className=' btn-contact' type='submit'
                                onclick={() => {
                                }}
                            >submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </ div>
    )
}
